/**
 * Buckets `items` by `groupKeyOf(item)` (a plain string, "" for missing),
 * orders groups alphabetically with the uncategorized ("") bucket last, and
 * sorts each group's items with `sortFn`. Pass groupBy="none" to skip
 * grouping entirely -- returns a single unlabeled group.
 */
export function groupAndSort(items, { groupBy, groupKeyOf, sortFn, uncategorizedLabel }) {
  if (!groupBy || groupBy === "none") {
    return [{ key: "__all", label: null, items: [...items].sort(sortFn) }];
  }
  const buckets = new Map();
  items.forEach((item) => {
    const key = groupKeyOf(item) || "";
    if (!buckets.has(key)) buckets.set(key, []);
    buckets.get(key).push(item);
  });
  const keys = [...buckets.keys()].sort((a, b) => {
    if (!a && b) return 1;
    if (a && !b) return -1;
    return a.localeCompare(b);
  });
  return keys.map((key) => ({
    key: key || "__uncategorized",
    label: key || uncategorizedLabel,
    items: [...buckets.get(key)].sort(sortFn),
  }));
}

/** Distinct, sorted, non-empty values of `keyOf(item)` across `items`. */
export function distinctValues(items, keyOf) {
  return [...new Set(items.map(keyOf).filter(Boolean))].sort();
}
